import { IconEdit } from "@/assets/icons/IconEdit";
import { DetailFooterShell } from "@/components/commons/DetailFooterShell";
import { Button } from "@/components/elements/Button";
import { AppRoutes } from "@/routes/config";
import { FC } from "react";
import { useNavigate } from "react-router-dom";

export const UserSettingFooter: FC = () => {
  const navigate = useNavigate();

  return (
    <DetailFooterShell justifyContent="flex-end">
      <Button variant="primary" size="sm" sx={{ width: "88px" }} onClick={() => navigate(AppRoutes.userSettingEdit)} startIcon={<IconEdit fontSize={20} />}>
        編集
      </Button>
    </DetailFooterShell>
  );
};
